import Vue from "vue";
import { mapGetters } from "vuex";

import { EventTrackingService, ObjectUtil, PartListService } from "@/services";

import { LoadingSpinner } from "@/components";
import { inputValidateState } from "@/components/mixins/inputValidateState";

import { IPartListItemDto } from "@/types";

export default Vue.extend({
    name: "AddPartToList",
    mixins: [inputValidateState],
    components: {
        LoadingSpinner,
    },
    computed: {
        ...mapGetters(["user", "getContentItem", "partsLists"]),
        formIsValid(){

            if(this.quantity < 1){
                return false;
            }
            if(this.partListId == "")
            {
                return false;
            }
            if(this.partListId === "NEW" && this.newPartListName == ""){
                return false;
            }
            return true;
        }
    },
    props: {
        partId: Number,
        oemPartCode: String,
        initialQuantity: {
            type: Number,
            default: 1,
        },
    },

    data: () => ({
        showThankYou: false,
        showSendError: false,
        isBusy: false,
        errorMessage: "",

        // form fields
        partListId: "",
        newPartListName: "",
        quantity: 1,
        invalidFormMessage: "",
    }),
    created() {
        this.quantity = this.initialQuantity > 1 ? this.initialQuantity : 1;

        if (!this.partList) {
            this.loadPartList();
        }
    },
    methods: {
        async submitPartListForm() {
            if (this.partListId === "NEW") {
                await this.createNewPartsList();
            }

            await this.addPartToList();
        },

        async loadPartList() {
            try {
                this.isBusy = true;

                const request = {
                    accountId: this.user.PrimaryAccountId,
                    userId: this.user.UserId,
                    numberItemsToReturn: 10
                };

                const partsList = await PartListService.GetPartListSummary(request);

                this.$store.commit("SET_PARTS_LISTS", partsList);
            } finally {
                this.isBusy = false;
            }
        },

        async createNewPartsList() {
            try {
                const request = {
                    accountId: this.user.PrimaryAccountId,
                    userId: this.user.UserId,
                    partListName: this.newPartListName,
                };

                const newList = await PartListService.CreateNewPartList(request);

                this.$store.commit("pushTimedMessage", {
                    header: "Successfully created new part list",
                    IsError: false,
                    seconds: 15,
                });

                await this.loadPartList();

                this.partListId = newList.Id;
            } catch {
                this.$store.commit("pushTimedMessage", {
                    header: "Error creating new part list",
                    IsError: true,
                    seconds: 15,
                });
            }
        },

        async addPartToList() {
            try{
                if( !this.partListId){
                    this.invalidFormMessage = "Please select a part list."
                    return;
                }

                this.isBusy = true
                const part = ObjectUtil.createInstance<IPartListItemDto>({
                    Id: this.partId,
                    OemPartCode: this.oemPartCode,
                    Quantity: this.quantity,
                });

                const request = {
                    accountId: this.user.PrimaryAccountId,
                    userId: this.user.UserId,
                    dealerCode: this.user.DealerCode,
                    partListId: this.partListId,
                    partListItems: [part],
                };

                await PartListService.AddPartListItems(request);

                EventTrackingService.trackEvent({
                    category: "PartLists-AddItem",
                    action: "CAT LIFT TRUCKS",
                    label: this.oemPartCode,
                    value: this.quantity,
                });

                this.$store.commit("pushTimedMessage", {
                    header: "Successfully added to part list",
                    IsError: false,
                    seconds: 15
                });
            } catch{
                this.$store.commit("pushTimedMessage", {
                    header: "Error adding to part list",
                    IsError: true,
                    seconds: 15,
                });
            } finally{
                this.isBusy = false;
            }
            
        },

        clearValidationMessage(){
            this.invalidFormMessage = ""
        }
    },
});
